import React from 'react';
import './SocialSection.css';
import icon_discord from '../assets/icons/icon-11.webp' // Discord
import icon_youtube from '../assets/icons/icon-10.webp' // YouTube
import icon_tiktok from '../assets/icons/icon-33.webp' // TikTok
import icon_reddit from '../assets/icons/icon-34.webp' // Reddit
import icon_x from '../assets/icons/icon-09.webp' // X
import icon_facebook from '../assets/icons/icon-07.webp' // Facebook
import icon_instagram from '../assets/icons/icon-08.webp' // Instagram

const jumpTo = (url: any) => {
  const w: any = window.open('_black')
  w.location.href = url
}

interface SocialSectionProps {
  isMobile: boolean;
}

const SocialSection: React.FC<SocialSectionProps> = ({ isMobile }) => {
  if (!isMobile) return null; // Only show on mobile

  const socialPlatforms = [
    { name: 'Discord', icon: icon_discord, url: 'https://discord.gg/U2WCanzz7e' },
    { name: 'YouTube', icon: icon_youtube, url: 'https://www.youtube.com/@PaxAutocratica' },
    { name: 'TikTok', icon: icon_tiktok, url: 'http://tiktok.com/@PaxAutocratica' },
    { name: 'Reddit', icon: icon_reddit, url: 'https://www.reddit.com/r/PaxAutocratica/' },
    { name: 'Twitter', icon: icon_x, url: 'https://x.com/paxAutocratica/' },
    { name: 'Facebook', icon: icon_facebook, url: 'https://www.facebook.com/PaxAutocratica/' },
    { name: 'Instagram', icon: icon_instagram, url: 'https://www.instagram.com/paxautocratica' },
  ];

  return (
    <section className="social-section">
      <h3 className="social-title">Follow us on</h3>
      <div className="social-icons">
        {socialPlatforms.map((platform, index) => (
          <button key={index} className="social-icon" onClick={() => jumpTo(platform.url)}>
            <img
              src={platform.icon}
              alt={platform.name}
              height={24}
              width={24}
            />
          </button>
        ))}
      </div>
    </section>
  );
};

export default SocialSection;